// Mock data for SteelCraft Welders Landing Page

export const heroData = {
  headline: "Precision Engineering, Masterful Welding",
  subheadline: "Expert welding solutions for industrial and commercial projects across South Africa. Quality craftsmanship, certified expertise, and unwavering commitment to safety standards.",
  primaryCTA: "Get a Free Quote",
  secondaryCTA: "Our Services",
  backgroundImage: "https://images.unsplash.com/photo-1508465818649-14a170138405?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHx3ZWxkaW5nJTIwc3BhcmtzfGVufDB8fHx8MTc2OTY4MzQ2NHww&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  title: "About SteelCraft Welders",
  description: "At SteelCraft Welders, we bring together cutting-edge welding technology and time-honored craftsmanship to serve South Africa's industrial and commercial sectors. Our team of certified welders is dedicated to delivering precision results that exceed SABS standards. We pride ourselves on our unwavering commitment to quality, adherence to stringent safety protocols, and our ability to tackle projects of any scale with expertise and efficiency."
};

export const servicesData = [
  {
    id: 1,
    title: "Structural Welding",
    description: "Heavy-duty construction and framework solutions for commercial and industrial buildings across South Africa. From steel beams to complex structural systems, we ensure every weld meets SABS load-bearing standards.",
    image: "https://images.unsplash.com/photo-1709244596178-43f51715416d",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Custom Fabrication",
    description: "Bespoke metalwork tailored to your specific engineering needs. We transform raw materials into precision-crafted components, from architectural features to specialized industrial equipment for mines, factories, and commercial sites.",
    image: "https://images.unsplash.com/photo-1531053326607-9d349096d887",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Mobile Welding",
    description: "On-site repair and installation services throughout Gauteng and surrounding provinces. Fully equipped mobile units ensure minimal downtime and maximum convenience for your operations.",
    image: "https://images.unsplash.com/photo-1615219023549-5c9abdb7df9a",
    icon: "Truck"
  },
  {
    id: 4,
    title: "Industrial Repairs",
    description: "Comprehensive maintenance for heavy machinery, mining equipment, and plant operations. Our rapid response team ensures your business stays running with expert welding repairs and preventative maintenance.",
    image: "https://images.unsplash.com/photo-1529479627062-5f1f0b88912a",
    icon: "Settings"
  }
];

export const featuresData = [
  {
    id: 1,
    title: "SABS Certified Welders",
    description: "All team members hold current South African certifications and undergo continuous training",
    icon: "Award"
  },
  {
    id: 2,
    title: "Quick Turnaround",
    description: "Fast project completion without compromising quality or safety standards",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Precision Tolerances",
    description: "Advanced equipment and techniques ensure accuracy to exact specifications",
    icon: "Target"
  },
  {
    id: 4,
    title: "Safety First",
    description: "Rigorous safety protocols and full compliance with SA OHS Act requirements",
    icon: "Shield"
  },
  {
    id: 5,
    title: "Quality Materials",
    description: "Premium grade South African steel and welding supplies for lasting durability",
    icon: "CheckCircle"
  },
  {
    id: 6,
    title: "24/7 Emergency",
    description: "Round-the-clock availability for urgent repair and maintenance needs across Gauteng",
    icon: "Phone"
  }
];

export const portfolioData = [
  {
    id: 1,
    title: "Industrial Steel Framework",
    image: "https://images.unsplash.com/photo-1609627016501-b862497c7294",
    category: "Structural"
  },
  {
    id: 2,
    title: "Commercial Building Framework",
    image: "https://images.unsplash.com/photo-1557143930-d4e7a86a194f",
    category: "Commercial"
  },
  {
    id: 3,
    title: "Architectural Steel Complex",
    image: "https://images.unsplash.com/photo-1444847840129-0ac27946a0a7",
    category: "Architectural"
  },
  {
    id: 4,
    title: "Custom Metal Fabrication",
    image: "https://images.unsplash.com/photo-1531053326607-9d349096d887",
    category: "Custom"
  },
  {
    id: 5,
    title: "Industrial Plant Installation",
    image: "https://images.pexels.com/photos/5623179/pexels-photo-5623179.jpeg",
    category: "Industrial"
  },
  {
    id: 6,
    title: "Precision Metalwork",
    image: "https://images.unsplash.com/photo-1689961476752-cc6cc3a02f86",
    category: "Precision"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "James Richardson",
    role: "Construction Site Manager",
    company: "Apex Building Solutions",
    content: "SteelCraft Welders delivered exceptional structural welding for our 15-story commercial project. Their attention to detail and ability to meet tight deadlines was impressive. Every weld passed inspection on the first try.",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. Sarah Martinez",
    role: "Chief Engineer",
    company: "Precision Manufacturing Corp",
    content: "We've relied on SteelCraft for our custom fabrication needs for over a year now. Their weld quality is consistently outstanding, and their team truly understands precision tolerances. Highly recommended for any engineering project.",
    rating: 5
  },
  {
    id: 3,
    name: "Michael Chen",
    role: "Facilities Director",
    company: "Industrial Solutions Group",
    content: "When our production line went down, SteelCraft's mobile welding team was on-site within hours. They completed the emergency repairs professionally and efficiently, saving us thousands in downtime costs. Outstanding service!",
    rating: 5
  }
];

export const contactData = {
  phone: "087 265 4266",
  email: "info@steelcraftwelders.co.za",
  address: "Johannesburg, Gauteng, South Africa",
  hours: "Monday - Friday: 07:00 - 18:00 | Emergency Service: 24/7"
};
